import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import {
  DelayActivityTypeCategoryDocument,
  delayActivityTypeCategoryPullQueryBuilder,
} from './queryBuilder';

export function delayActivityTypeCategoryFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<DelayActivityTypeCategoryDocument> {
  const syncConfig = configBuilder<DelayActivityTypeCategoryDocument>(
    RxdbCollectionNameV2.DELAY_ACTIVITY_TYPE_CATEGORY,
  );
  doNotAutoSync(syncConfig);

  // `delayActivityTypeCategoryPullQueryBuilder` uses `delayActivityTypeCategoryFeed` which is based on `activity_type_category`.
  pull(syncConfig, delayActivityTypeCategoryPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.DELAY_ACTIVITY_TYPE_CATEGORY, replicationState, [sites]);
}
